import React from 'react'
import Session from "../../helpers/Session";

class InformacionPropietario extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            propietario: null
        };

    }

    componentDidMount() {
        const usuario = Session.getLogin();
        this.setState({
            propietario: usuario
        });
    }

    render() {
        return (
            <table className='custom-table'>
                <tbody>
                <tr>
                    <th style={{width: '200px'}}>Nro. Documento</th>
                    <td>{this.state.propietario?.terceroDocumento}</td>
                    <th style={{width: '200px'}}>Nombre</th>
                    <td>{`${this.state.propietario?.terceroNombre1} ${this.state.propietario?.terceroNombre2} 
                    ${this.state.propietario?.terceroApellido1} ${this.state.propietario?.terceroApellido2}`}</td>
                </tr>
                <tr>
                    <th>Celular</th>
                    <td>{this.state.propietario?.terceroCel}</td>
                    <th>Teléfono</th>
                    <td>{this.state.propietario?.terceroTel}</td>
                </tr>
                <tr>
                    <th>Email</th>
                    <td>{this.state.propietario?.terceroMail}</td>
                    <th>Dirección</th>
                    <td>{this.state.propietario?.terceroDireccion}</td>
                </tr>
                </tbody>
            </table>
        );
    }
}

export default InformacionPropietario